import { Img, Heading } from "../../components";
import SolutionsFeature from "../../components/SolutionsFeature";
import React, { Suspense } from "react";

const technologyAdvancementsList = [
  {
    featureheading: "Machine Boost",
    description: (
      <>
        Real-time OEE
        <br />
        Machine Diagnostics & Prognostics
        <br />
        Predictive maintenance
        <br />
        Remote monitoring and control
        <br />
        Routing flexibility
        <br />
        Augmented reality for MRO
      </>
    ),
  },
  {
    featureheading: "Process Boost",
    description: (
      <>
        Remote monitoring & Performance management
        <br />
        AI monitored safe-workplace
        <br />
        Real-time inventory stock
        <br />
        Data-driven demand prediction
        <br />
        Future inventory requirement
        <br />
        Digital quality thread accessible to management, shopfloor personnel, OEMs, and customers
        <br />
        AI advance quality warning and bottleneck identification
        <br />
        Remote maintenance & prescriptive AI
      </>
    ),
  },
  {
    featureheading: "Manpower Boost",
    description: (
      <>
        AI Image Vision System with people and posture analytics
        <br />
        AI-based bot for manual and SOP assistance, natural language querying
        <br />
        AI monitored safe-workplace, overcrowding and human under load detection
        <br />
        Digital thread for personnel
        <br />
        AR/VR{" "}
      </>
    ),
  },
];

export default function SolutionsOverviewSection() {
  return (
    <>
      {/* Solutions Overview Section */}
      <div className="mt-[126px] flex flex-col items-center justify-center overflow-hidden md:mt-8 sm:mt-6">
        <Img
          src="images/img_megaphone.svg"
          alt="Megaphone Image"
          className="h-[34px] md:w-[50px] sm:w-[40px]"
        />
        <div className="flex flex-col items-center gap-12 px-6 w-full max-w-[1440px] md:gap-8 sm:px-4">
          {/* Heading Section */}
          <div className="flex flex-col items-center gap-4 w-full">
            <Heading
              size="headinglg"
              as="h2"
              className="text-[17.12px] font-bold uppercase tracking-[1.71px] text-amber-800_01 md:text-[16px] sm:text-[14px]"
            >
              Modules
            </Heading>
            <Heading
              as="h3"
              className="text-center font-spacegrotesk text-[46px] font-bold leading-[59px] text-gray-800 md:text-[36px] md:leading-[48px] sm:text-[24px] sm:leading-[32px]"
            >
              <span className="font-normal">
                Revolutionize Manufacturing with Our <br />
              </span>
              <span className="text-amber-700">Smart Factory Platform</span>
            </Heading>
          </div>

          {/* Solutions Features Section */}
          <div className="grid grid-cols-1 gap-8 w-full lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 sm:gap-6">
            <Suspense fallback={<div>Loading feed...</div>}>
              {technologyAdvancementsList.map((feature, index) => (
                <SolutionsFeature
                  {...feature}
                  key={`featuresList${index}`}
                  className=""
                />
              ))}
            </Suspense>
          </div>
        </div>
        <Img
          src="images/img_upload.svg"
          alt="Image Upload"
          className="h-[34px] md:w-[50px] sm:w-[40px]"
        />
      </div>
    </>
  );
}
